export const translationsOneway = {
  'ALL--oneway--key': 'Verkehrsrichtung',
  'atlas_bikelanes--oneway--key': 'Verkehrsrichtung',
  'atlas_bikelanes--oneway=assumed_no--tooltip': 'Wenn keine explizite Angabe vorliegt, nehmen wir für bestimmte Infrastruktur an, dass der Radverkehr in beiden Richtungen fahren darf.',
  'atlas_bikelanes--oneway=assumed_no': 'Wahrscheinlich beide Richtungen',
  'atlas_bikelanes--oneway=car_not_bike': 'Beide Richtungen für Fahrrad; Einbahnstraße für Kfz',
  'atlas_bikelanes--oneway=implicit_yes--tooltip': 'Wenn keine explizite Angabe vorliegt, nehmen wir für bestimmte Infrastruktur an, dass der Radverkehr in nur eine Richtungen fahren darf.',
  'atlas_bikelanes--oneway=implicit_yes': 'Wahrscheinlich eine Richtung', //  Wir verwenden hier nicht "Einrichtungsradweg" da diese Angabe für bspw. Buspuren irreführend ist
  'atlas_bikelanes--oneway=no': 'Beide Richtungen',
  'atlas_bikelanes--oneway=yes': 'Eine Richtung', //  Wir verwenden hier nicht "Einrichtungsradweg" da diese Angabe für bspw. Buspuren irreführend ist
  'atlas_roads--oneway--key': 'Verkehrsrichtung',
  'atlas_roads--oneway_bicycle--key': 'Verkehrsrichtung Fahrrad',
  'atlas_roads--oneway_bicycle=no': 'Beide Richtungen für Radverkehr',
  'atlas_roads--oneway_bicycle=yes': 'Eine Richtung (auch für Radverkehr)',
  'atlas_roads--oneway=no': 'Beide Richtungen',
  'atlas_roads--oneway=yes_dual_carriageway': 'Einbahnstraße da separate Geometrie pro Seite',
  'atlas_roads--oneway=yes': 'Einbahnstraße',
}
